import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
} from 'react-md';

import SegmentsTableActions from './SegmentsTableActions';
import SegmentRow from './SegmentRow';
import { invokeBackendApi } from '../../libs/awsLib';


class SegmentsTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      acceptedItems: [],
      reportedItems: [],
      rejectedItems: [],
      selectedRows: [],
      journeyId: props.journey.journeyId,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.journey.journeyId !== prevState.journeyId) {
      return { journeyId: nextProps.journey.journeyId, selectedRows: [] };
    }
    return null;
  }

  reportSelected = (segments, errorType, errorReason) => {
    const { selectedRows, acceptedItems, reportedItems } = this.state;
    this.setState({ isLoading: true });
    const {
      userAttributes: { isPsy },
    } = this.props;

    if (isPsy) { // Accept batch method
      const path = '/segments/accept';
      const body = { segmentIds: segments };
      invokeBackendApi({ path, method: 'POST', body }).then(() => {
        this.setState({
          isLoading: false, acceptedItems: [...acceptedItems, ...selectedRows], selectedRows: [],
        });
      });
    } else { // Reject
      const body = { errorType, errorReason };
      const invokeApiPromises = segments.map((segmentId) => {
        const path = `/segments/${segmentId}/report`;
        return invokeBackendApi({ path, method: 'POST', body });
      });
      Promise.all(invokeApiPromises).then(() => {
        this.setState({
          isLoading: false, reportedItems: [...reportedItems, ...selectedRows], selectedRows: [],
        });
      });
    }
  };

  rejectSelected = (segments) => {
    const { selectedRows, rejectedItems } = this.state;
    this.setState({ isLoading: true });

    const invokeApiPromises = segments.map((segmentId) => {
      const path = `/segments/${segmentId}/reject`;
      return invokeBackendApi({ path, method: 'POST' });
    });

    Promise.all(invokeApiPromises).then(() => {
      this.setState({
        isLoading: false, rejectedItems: [...rejectedItems, ...selectedRows], selectedRows: [],
      });
    });
  }

  handleRowToggle = (row, selected) => {
    const {
      selectedRows, acceptedItems, reportedItems, rejectedItems,
    } = this.state;
    const { segments, userAttributes: { isPsy } } = this.props;

    let newSelectedRows;
    if (row === 0) {
      newSelectedRows = selected ? segments.filter(s => s.segmentState !== 'ACCEPTED' &&
      s.segmentState !== 'REJECTED' &&
      !acceptedItems.includes(s.segmentId) &&
      !rejectedItems.includes(s.segmentId) &&
      (isPsy || (s.segmentState !== 'REPORTED' && !reportedItems.includes(s.segmentId))))
        .map(s => s.segmentId) : [];
    } else {
      const selectedSegmentId = segments[row - 1].segmentId;
      if (selectedRows.includes(selectedSegmentId)) {
        newSelectedRows = selectedRows.filter(sr => sr !== selectedSegmentId);
      } else {
        newSelectedRows = [...selectedRows, selectedSegmentId];
      }
    }
    this.setState({ selectedRows: newSelectedRows });
  };

  render() {
    const {
      intl, segments, activeSegment, onSegmentClick, userAttributes, journey,
    } = this.props;
    const {
      selectedRows, isLoading, acceptedItems, reportedItems, rejectedItems,
    } = this.state;
    return (
      <Card tableCard>
        <SegmentsTableActions
          journey={journey}
          onReportClick={this.reportSelected}
          onRejectClick={this.rejectSelected}
          userAttributes={userAttributes}
          selectedRows={selectedRows}
        />
        <DataTable baseId="segments" className="scrollable speedingsTable-psy segmentsTable" onRowToggle={this.handleRowToggle}>
          <TableHeader>
            <TableRow>
              <TableColumn >{intl.formatMessage({ id: 'journeyDetails.speed' })}</TableColumn>
              <TableColumn >{intl.formatMessage({ id: 'journeyDetails.limit' })}</TableColumn>
              <TableColumn >{intl.formatMessage({ id: 'journeyDetails.time' })}</TableColumn>
              <TableColumn >{intl.formatMessage({ id: 'journeyDetails.street' })}</TableColumn>
              <TableColumn >{intl.formatMessage({ id: 'journeyDetails.gps' })}</TableColumn>
              <TableColumn />{/* Kebab MenuActions */}
            </TableRow>
          </TableHeader>
          <TableBody style={{ height: '520px' }}>
            {segments.map(segment => (
              <SegmentRow
                key={segment.start}
                segment={segment}
                userAttributes={userAttributes}
                activeSegment={activeSegment}
                onSegmentClick={onSegmentClick}
                selected={selectedRows.includes(segment.segmentId)}
                isLoading={isLoading && selectedRows.includes(segment.segmentId)}
                isAccepted={acceptedItems.includes(segment.segmentId)}
                isReported={reportedItems.includes(segment.segmentId)}
                isRejected={rejectedItems.includes(segment.segmentId)}
              />
          ))}
          </TableBody>
        </DataTable>
      </Card>
    );
  }
}

SegmentsTable.propTypes = {
  intl: intlShape.isRequired,
  segments: PropTypes.array.isRequired,
  journey: PropTypes.object,
  activeSegment: PropTypes.object,
  onSegmentClick: PropTypes.func.isRequired,
  userAttributes: PropTypes.shape({
    isPsy: PropTypes.bool.isRequired,
  }),
};

export default injectIntl(SegmentsTable);



// WEBPACK FOOTER //
// ./src/components/Journey/SegmentsTable.js